// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name=\"Text\"] {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: default;\n}\n  [name=\"Text\"].selectable {\n    cursor: pointer;\n  }\n  [name=\"Text\"] textarea {\n    font-family: 'Montserrat', sans-serif;\n    background: none;\n    box-shadow: none;\n    border: 1px dotted #000;\n    width: 100%;\n    height: 100%;\n    padding: 2px;\n    font-weight: 600;\n    line-height: 27px;\n  }", ""]);
// Exports
module.exports = exports;
